import useModel from './useModel'

export default function useTitleField(modelId?: string) {
  const { data: model } = useModel(modelId)
  const titleField = model?.fields.find((field) => field.meta.useAsTitle)
  return titleField
}
